import { Container, Divider, Grid, List } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { IReaderStationStatus } from '../../../models/IReaderStatus';
import MonitoringServiceInstance from '../../../services/MonitoringService';
import ReaderMonitorDetail from './ReaderMonitorDetail';
import { useTranslation } from 'react-i18next';
import OntimeBreadcrumb from '../../common/OntimeBreadcrumb';

const useStyles = makeStyles((theme) => ({
    table: {
        tableLayout: 'auto'
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    appBarSpacer: theme.mixins.toolbar,
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    }
}));

export default function ReadersMonitor() {
    const [readers, setReaders] = useState<IReaderStationStatus[]>([]);
    const classes = useStyles();
    const { t } = useTranslation("common");

    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchData = async () => {
            const readers = await MonitoringServiceInstance.getReadersStatus(source.token);
            setReaders(readers);
        };
        fetchData().catch(reason => {
            if (!axios.isCancel(reason)) {
                console.error(reason);
            }
        });
        return () => {
            source.cancel();
        };
    }, []);

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <OntimeBreadcrumb nameMap={{}} current={t('admin.monitoring')} />
                    </Grid>
                    <Grid item xs={12}>
                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                            {readers.map((reader, index) =>
                                index === 0 ? <ReaderMonitorDetail key={reader.readerId} reader={reader} />
                                    : <Fragment key={reader.readerId}>
                                        <Divider variant="inset" component="li" />
                                        <ReaderMonitorDetail reader={reader} />
                                    </Fragment>
                            )}
                        </List>
                    </Grid>
                </Grid>
            </Container>
        </main>
    );
}